var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFavorites = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m10 1 2.939 5.955 6.572.955-4.756 4.635 1.123 6.545L10 16l-5.878 3.09 1.123-6.545L.489 7.91l6.572-.955zm0 4L8.237 8.573l-3.943.573 2.853 2.781-.674 3.927L10 14l3.527 1.854-.674-3.927 2.853-2.781-3.943-.573z"
})));
export default SvgIconFavorites;